import { render, staticRenderFns } from "./InvoiceEditor.yaml?vue&type=template&id=630e8424&component"
import script from "./InvoiceEditor.yaml?vue&type=script&lang=ts&component"
export * from "./InvoiceEditor.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports